export const environment = {
    production: true,
    apiUrl: 'https://api.formsaware.com',
    frontendDomain: 'app.formsaware.com',
    keycloakUrl: 'https://auth.formsaware.com',
    keycloakRealm: 'FormsAWare',
    keycloakClientId: 'client-fe',
    version: '__VERSION__',
};
